import type React from "react";
import OTPVerificationForm from "./otp-verify-form.components";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useToast } from "../hooks/use-toast";
import { handleHttpError } from "../utils/utils";
import { useUserStore } from "../store/user.store";
import { useAuthenticationStore } from "../store/authentication.store";
import { useEphemeralVerifyOtpCommonHttp } from "../hooks/http/common/users/ephemeral-verify-otp.common.http";
import { useEphemeralResendOtpCommonHttp } from "../hooks/http/common/users/ephemeral-resend-otp.common.http";

const OTPPhoneEphemeral: React.FunctionComponent = () => {
	const { authenticationState, setAuthenticationState } =
		useAuthenticationStore();
	const { fetching, execute: verifyOtpHttp } =
		useEphemeralVerifyOtpCommonHttp();
	const { execute: resendOtpHttp } = useEphemeralResendOtpCommonHttp();
	const navigate = useNavigate();
	const { toast } = useToast();
	const [campaign] = useSearchParams();

	const campaignId= campaign.get("campaign");

	const { login } = useUserStore();

	async function onResend() {
		const response = await resendOtpHttp({
			body: { id: authenticationState?.otp.id || "" },
		});
		if (!response.success) {
			return handleHttpError(response, toast);
		}
		setAuthenticationState({
			...authenticationState,
			otp: response.data,
		});
	}

	async function VerifyOtp(pin: string) {
		console.log(authenticationState?.otp);
		if (!authenticationState?.otp.id) {
			return toast({
				content: "error in getting id",
				toastType: "error",
			});
		}

		const response = await verifyOtpHttp({
			body: {
				id: authenticationState.otp.id,
				otp: pin,
			},
		});
		if (!response.success) {
			return toast({
				content: response.error.message,
				toastType: "error",
			});
		}

		login(response.data.token, response.data.user, null);

		toast({
			content: `Welcome Onboard ${response.data.user.name} 🎉`,
			toastType: "success",
		});
		navigate(`/ephemeral/brand-dash/${campaignId}/draft-submissions`);
	}

	if (!authenticationState) {
		return <></>;
	}

	return (
		<OTPVerificationForm
			title="Enter OTP"
			description={`enter the otp sent to +91-${authenticationState.phone}`}
			caller={VerifyOtp}
			loading={fetching}
			onResend={onResend}
			canResend={authenticationState.otp.canResend}
			resendIn={authenticationState.otp.resendIn}
		/>
	);
};

export default OTPPhoneEphemeral;
